var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-main"},[_c('div',{staticClass:"head"},[_c('pageTitle',{attrs:{"pageTitle":"推屏卡片"}}),_c('PushCards')],1),(_vm.$route.query.type != 5 && _vm.webinarState != 4)?_c('begin-play',{attrs:{"webinarId":_vm.$route.params.str}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }